import bdServices from './bd-services';
import { PDFDocument, rgb, degrees } from 'pdf-lib';

const terminal = {};

terminal.DownloadFile = async function (id) {
  const options = {
    method: 'get',
    headers: { 'Content-type': 'multipart/json', 'Accept': 'application/json' },
    url: `/servidores/sasisopa/media/api/download.php?id=${id}&User-Id=${sessionStorage.getItem('idUsuario')}`,
  };

  try {
    const response = await bdServices(options);
    const data = response.data.data;

    if (data.mime_type === "application/pdf") {
      if (!data.content) {
        throw new Error("Contenido PDF vacío o no válido");
      }

      const pdfBytes = Uint8Array.from(atob(data.content), c => c.charCodeAt(0));

      const pdfDoc = await PDFDocument.load(pdfBytes);
      const pages = pdfDoc.getPages();
      const fontSize = 35;
      const color = rgb(150 / 255, 150 / 255, 150 / 255);

      pages.forEach(page => {
        page.drawText('COPIA CONTROLADA ' + data.version, {
          x: page.getWidth() / 2 - (fontSize * 4),
          y: page.getHeight() / 2 - (fontSize * 4),
          size: fontSize,
          color: color,
          rotate: degrees(45),
          opacity: 0.4,
        });
      });

      const newPdfBytes = await pdfDoc.save();
      const newPdfBlob = new Blob([newPdfBytes], { type: 'application/pdf' });
      const newPdfUrl = URL.createObjectURL(newPdfBlob);

      const link = document.createElement('a');
      link.href = newPdfUrl;
      link.download = "COPIA_CONTROLADA_" + data.version + "_" + data.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return response;
    } else {
      return response;
    }
  } catch (err) {
    console.error("Error en DownloadFile:", err);
    throw err;
  }
};

//#region Terminales
terminal.getTerminales = async function () {
  const options = {
    method: 'get',
    headers: { 'Content-type' : 'multipart/json', 'Accept': 'application/json'},
    url: '/servidores/sasisopa/terminales/api/get.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}
terminal.postTerminal = async function (data) {
  let formData = new FormData()
  formData.append('name', data.name)
  formData.append('User-Id', sessionStorage.getItem('idUsuario'))

  const options = {
    method: 'POST',
    data: formData
  };
  const response = await bdServices('/servidores/sasisopa/terminales/api/store.php', options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
terminal.UpdateTerminal = async function (data) {
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({  "id": data.id,
                            "name":data.name,
                            "User-Id": sessionStorage.getItem('idUsuario')
                          })
  };
  const response = await bdServices('/servidores/sasisopa/terminales/api/update.php', options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
terminal.DeleteTerminal = async function (id) {
  const options = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({  "id": id,
                            "User-Id": sessionStorage.getItem('idUsuario') })
  };
  const response = await bdServices('/servidores/sasisopa/terminales/api/delete.php', options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
//#endregion

//#region Documentos
terminal.getDocuments = async function (id) {
  const options = {
    method: 'get',
    headers: {'Content-type': 'multipart/json',
              'Accept': 'application/json',
              },

    url: `/servidores/sasisopa/terminales/api/get_documents.php?id=${id}`,

  };
  const response = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
terminal.postDocument = async function (data) {
  let formData = new FormData()
  formData.append('name', data.name)
  formData.append('consecutive', data.consecutive)
  formData.append('code', data.code)
  formData.append('terminal_id', data.terminal_id)
  formData.append('User-Id', sessionStorage.getItem('idUsuario'))
  const options = {
    method: 'post',
    url: '/servidores/sasisopa/documentos/api/store.php',
    data: formData
  };
  const response = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
terminal.UpdateDocument = async function (data) {
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({  "id": data.id,
                            "name":data.name,
                            "code":data.code,
                            "terminal_id":data.terminal_id,
                            "consecutive":data.consecutive,
                            "User-Id": sessionStorage.getItem('idUsuario')
                          })
  };
  const response = await bdServices('/servidores/sasisopa/documentos/api/update.php', options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
terminal.DeleteDocument = async function (id) {
  const options = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({"id": id,
                          "User-Id": sessionStorage.getItem('idUsuario')
                        })
  };
  const response = await bdServices('/servidores/sasisopa/documentos/api/delete.php', options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
//#endregion

//#region Ambitos
terminal.getAmbit = async function (id) {
  const options = {
    method: 'get',
    headers: { 'Content-type': 'multipart/json', 'Accept': 'application/json' },
    url: `/servidores/sasisopa/documentos/api/get_ambits.php?id=${id}`,
  };
  const response = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
terminal.postAmbit = async function (data) {
  let formData = new FormData()
  formData.append('name', data.name)
  formData.append('consecutive', data.consecutive)
  formData.append('code', data.code)
  formData.append('document_id', data.document_id)
  formData.append('User-Id', sessionStorage.getItem('idUsuario'))
  const options = {
    method: 'post',
    url: '/servidores/sasisopa/ambitos/api/store.php',
    data: formData
  };
  const response = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
terminal.UpdateAmbit = async function (data) {
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({  "id": data.id,
                            "name":data.name,
                            "code":data.code,
                            "document_id":data.terminal_id,
                            "consecutive":data.consecutive,
                            "User-Id": sessionStorage.getItem('idUsuario')
                          })
  };
  const response = await bdServices('/servidores/sasisopa/ambitos/api/update.php', options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
terminal.DeleteAmbit = async function (id) {
  const options = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({"id": id,
                          "User-Id": sessionStorage.getItem('idUsuario')
                        })
  };
  const response = await bdServices('/servidores/sasisopa/ambitos/api/delete.php', options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
//#endregion

//#region Archivos
terminal.getFiles = async function (id) {
  const options = {
    method: 'get',
    headers: { 'Content-type': 'multipart/json', 'Accept': 'application/json' },
    url: `/servidores/sasisopa/ambitos/api/get_medias.php?id=${id}`,
  };
  const response = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
terminal.postFiles = async function (data) {
  let formData = new FormData()
  formData.append('name', data.name)
  formData.append('file', data.file)
  formData.append('id', data.id)
  formData.append('User-Id', sessionStorage.getItem('idUsuario'))
  const options = {
    method: 'post',
    url: '/servidores/sasisopa/ambitos/api/store_files.php',
    data: formData
  };
  const response = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
terminal.DeleteFiles = async function (id) {
  const options = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({"id": id,
                          "User-Id": sessionStorage.getItem('idUsuario')
                        })
  };
  const response = await bdServices('/servidores/sasisopa/media/api/delete.php', options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
terminal.getFile = async function (id) {
  const options1 = {
    method: 'get',
    headers: { 'Content-type': 'multipart/json', 'Accept': 'application/json' },
    url: `/servidores/sasisopa/media/api/show.php?id=${id}&User-Id=${sessionStorage.getItem('idUsuario')}`,
  };

  const options2 = {
    method: 'get',
    headers: { 'Content-type': 'multipart/json', 'Accept': 'application/json' },
    url: `/servidores/sasisopa/media/api/download.php?id=${id}&User-Id=${sessionStorage.getItem('idUsuario')}`,
  };

  try {
    const response1 = await bdServices(options1).then(res => res.data);
    const response2 = await bdServices(options2).then(res => res.data);


    const combinedResponse = {
      ...response1,
      ...response2,
    };

    return combinedResponse;
  } catch (err) {
    console.error(err);
    throw err;
  }
};

terminal.postChangeRequest = async function (data) {
  let formData = new FormData()
  formData.append('User-Id', sessionStorage.getItem('idUsuario'))
  formData.append('media_id', data.media_id)
  formData.append('document_code', data.document_code)
  formData.append('document_name', data.document_name)
  formData.append('user_name', sessionStorage.getItem('nombre'))
  formData.append('user_work_job', sessionStorage.getItem('departamentoStr'))
  formData.append('document_type', data.document_type)
  formData.append('origin_of_change', data.origin_of_change)
  formData.append('reason_for_change', data.reason_for_change)
  formData.append('proposed_change', data.proposed_change)
  formData.append('current_status', data.current_status)
  const options = {
    method: 'post',
    url: '/servidores/sasisopa/solicitud/api/store.php',
    data: formData
  };
  const response = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
terminal.getRequestVoucher = async function (id) {
  const options = {
    method: 'get',
    headers: { 'Accept': 'application/pdf' },
    url: `https://ducter.com.mx/servidores/sasisopa/solicitud/reports/solicitud_Cambio.php?id=${id}&terminal=APT&User-Id=${sessionStorage.getItem('idUsuario')}`,
    responseType: 'blob',
  };

  const response = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });

  return response;
};
terminal.postChangeVoucher = async function (data) {
  let formData = new FormData()
  formData.append('User-Id', sessionStorage.getItem('idUsuario'))
  formData.append('id', data.id)
  formData.append('file', data.file)
  const options = {
    method: 'post',
    url: '/servidores/sasisopa/solicitud/api/store_files.php',
    data: formData
  };
  const response = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};

terminal.getLogs = async function () {
  const options = {
    method: 'get',
    headers: { 'Content-type': 'multipart/json', 'Accept': 'application/json' },
    url: `/servidores/sasisopa/auditor/api/get.php`,
  };
  const response = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};

terminal.getSolicitudes = async function () {
  const options = {
    method: 'get',
    headers: { 'Content-type': 'multipart/json', 'Accept': 'application/json' },
    url: `/servidores/sasisopa/solicitud/api/get.php`,
  };
  const response = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};

terminal.getSolicitudesUsuario = async function () {
  const options = {
    method: 'get',
    headers: { 'Content-type': 'multipart/json', 'Accept': 'application/json' },
    url: `/servidores/sasisopa/solicitud/api/get.php`,
  };
  var response = await bdServices(options)
  .then(res => {
    return {
      ...res.data,
      id_Usuario: parseInt(sessionStorage.getItem('idUsuario'),10)
    };
  })
  .catch((err) => {
    console.error(err);
    throw err;
  });

return response;
};

terminal.changeStatusSolicitudes = async function (_data) {
  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify({  "id": parseInt(_data.id,10),
                            "assessment_result": _data.assessment_result,
                            "reason_for_assessment_result": _data.reason_for_assessment_result,
                            "User-Id": parseInt(sessionStorage.getItem('idUsuario'),10),
                          })
  };
  console.log(JSON.stringify({  "id": _data.id,
  "assessment_result": 3,
  "reason_for_assessment": _data.reason_for_assessment,
  "User-Id": sessionStorage.getItem('idUsuario')
}));
  const response = await bdServices('/servidores/sasisopa/solicitud/api/manage.php', options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return response;
};
//#endregion

export default terminal



// WEBPACK FOOTER //
// ./src/services/axios_sasisopa.js